import { NgTemplateOutlet } from '@angular/common';
import { Component, input, TemplateRef } from '@angular/core';
import { BenefitsListIconTemplateContext } from './models/benefits-list-icon-template-context.interface';
import { BenefitsListItem } from './models/benefits-list-item.interface';

@Component({
  selector: 'app-benefits-list',
  templateUrl: './benefits-list.component.html',
  styleUrl: './benefits-list.component.scss',
  imports: [NgTemplateOutlet],
})
export class BenefitsListComponent {
  benefitsListItems = input.required<BenefitsListItem[]>();
  iconTemplate = input<TemplateRef<BenefitsListIconTemplateContext>>();
  title = input<string | undefined>(undefined);
}
